import { SUPER_PROJECT_NAME } from 'src/constants';

type LabelSuperNinjaUltraProps = {
  isTrial?: boolean;
  label?: string;
};

export const LabelSuperNinjaUltra = ({
  label,
  isTrial = false,
}: LabelSuperNinjaUltraProps) => {
  return (
    <label
      className="nj-label-free nj-label-superninja-ultra"
      data-e2e="label-tier-superninja-ultra"
    >
      {(label && `${SUPER_PROJECT_NAME} ${label}`) ||
        (isTrial ? `${SUPER_PROJECT_NAME} Trial` : 'Max')}
    </label>
  );
};
